/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowParallelVIcon20Solid = forwardRef('ArrowParallelVIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2.604 8.07a1 1 0 1 1-1.415-1.414l3.273-3.273a2.172 2.172 0 0 1 3.072 0l3.273 3.273A1 1 0 0 1 9.392 8.07L6.998 5.676V16.25a1 1 0 1 1-2 0V5.676L2.604 8.07Z" }),
        React.createElement("path", { d: "M15.002 14.324V3.75a1 1 0 1 0-2 0v10.574l-2.394-2.394a1 1 0 1 0-1.414 1.414l3.273 3.273a2.172 2.172 0 0 0 3.071 0l3.273-3.273a1 1 0 0 0-1.414-1.414l-2.394 2.394Z" })));
});
